import { computed } from 'vue';
import { useStore } from 'vuex';

export default function useOfgComposable()
{
    const store = useStore();

    /** @type {import("vue").ComputedRef<Map<"right"|"left", Fitting>>} */
    const fittings = computed(() => new Map([
        ['right', store.getters['lensOrder/getFitting']('right')],
        ['left', store.getters['lensOrder/getFitting']('left')],
    ]));

    /**
     * Check whether a fitting has an OFG button that has a value, is enabled,
     * and is not hidden.
     *
     * @param {?string} side Either "left" or "right". If no side is provided,
     *                       will recursively check both sides and return true
     *                       if either is accessible.
     * @returns {boolean}
     */
    function isOfgAccessible(side = null)
    {
        if(side === null)
        {
            return isOfgAccessible('right') || isOfgAccessible('left');
        }

        const fitting = fittings.value.get(side);
        if(!fitting)
        {
            return false;
        }

        const param = fitting.getPrototype().getParameterByCode('OFG_BUTTON');
        return param &&
            param.getValue() &&
            param.is_enabled &&
            param.form_display !== 'HIDDEN' &&
            param.form_splitted_display !== 'HIDDEN';
    }

    return {
        fittings,
        isOfgAccessible,
    };
};
